/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Warnings } from './Warnings';
import { WarningsFromJSON, WarningsFromJSONTyped, WarningsToJSON } from './Warnings';

/**
 * Represents the assessment results or assessment outputs including the scores per
 * indicator: performance, robustness etc., reference to the individual metric scores and any
 * errors that have occurred during the assessment.
 * @export
 * @interface RiskIndicator
 */
export interface RiskIndicator {
  /**
   *
   * @type {number}
   * @memberof RiskIndicator
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof RiskIndicator
   */
  performanceScore?: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskIndicator
   */
  robustnessScore?: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskIndicator
   */
  fairnessScore?: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskIndicator
   */
  explainabilityScore?: number | null;
  /**
   *
   * @type {string}
   * @memberof RiskIndicator
   */
  readonly performanceIncidentProbability: string;
  /**
   *
   * @type {string}
   * @memberof RiskIndicator
   */
  readonly robustnessIncidentProbability: string;
  /**
   *
   * @type {string}
   * @memberof RiskIndicator
   */
  readonly fairnessIncidentProbability: string;
  /**
   *
   * @type {string}
   * @memberof RiskIndicator
   */
  readonly explainabilityIncidentProbability: string;
  /**
   *
   * @type {Array<Error>}
   * @memberof RiskIndicator
   */
  readonly errors: Array<Error>;
  /**
   *
   * @type {number}
   * @memberof RiskIndicator
   */
  drift?: number | null;
  /**
   *
   * @type {Array<Warnings>}
   * @memberof RiskIndicator
   */
  readonly warnings: Array<Warnings>;
}

/**
 * Check if a given object implements the RiskIndicator interface.
 */
export function instanceOfRiskIndicator(value: object): value is RiskIndicator {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('performanceIncidentProbability' in value) || value['performanceIncidentProbability'] === undefined)
    return false;
  if (!('robustnessIncidentProbability' in value) || value['robustnessIncidentProbability'] === undefined) return false;
  if (!('fairnessIncidentProbability' in value) || value['fairnessIncidentProbability'] === undefined) return false;
  if (!('explainabilityIncidentProbability' in value) || value['explainabilityIncidentProbability'] === undefined)
    return false;
  if (!('errors' in value) || value['errors'] === undefined) return false;
  if (!('warnings' in value) || value['warnings'] === undefined) return false;
  return true;
}

export function RiskIndicatorFromJSON(json: any): RiskIndicator {
  return RiskIndicatorFromJSONTyped(json, false);
}

export function RiskIndicatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskIndicator {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    performanceScore: json['performance_score'] == null ? undefined : json['performance_score'],
    robustnessScore: json['robustness_score'] == null ? undefined : json['robustness_score'],
    fairnessScore: json['fairness_score'] == null ? undefined : json['fairness_score'],
    explainabilityScore: json['explainability_score'] == null ? undefined : json['explainability_score'],
    performanceIncidentProbability: json['performance_incident_probability'],
    robustnessIncidentProbability: json['robustness_incident_probability'],
    fairnessIncidentProbability: json['fairness_incident_probability'],
    explainabilityIncidentProbability: json['explainability_incident_probability'],
    errors: json['errors'],
    drift: json['drift'] == null ? undefined : json['drift'],
    warnings: (json['warnings'] as Array<any>).map(WarningsFromJSON),
  };
}

export function RiskIndicatorToJSON(
  value?: Omit<
    RiskIndicator,
    | 'id'
    | 'performanceIncidentProbability'
    | 'robustnessIncidentProbability'
    | 'fairnessIncidentProbability'
    | 'explainabilityIncidentProbability'
    | 'errors'
    | 'warnings'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    performance_score: value['performanceScore'],
    robustness_score: value['robustnessScore'],
    fairness_score: value['fairnessScore'],
    explainability_score: value['explainabilityScore'],
    drift: value['drift'],
  };
}
